import { ENV } from "@/constants";
import { getTokenFromFE } from "@/services/token";
import { NextRequest } from "next/server";

import wretch from "wretch";

export const beApi = wretch(`${ENV.BACKEND_URL}/api/v1`)
  .errorType("json")
  .resolve((r) => r.json());

export const feApi = wretch(`${ENV.NEXT_PUBLIC_BASE_URL}/api`)
  .errorType("json")
  .resolve((r) => r.json());

export const rawApi = wretch()
  .errorType("json")
  .resolve((r) => r.json());

export async function getRequestToken(req: NextRequest): Promise<string> {
  const bearerToken = req.headers.get("authorization");

  const token = bearerToken?.split(" ")[1];

  if (!token || token === "null") {
    const ntoken = await getTokenFromFE();

    return `Bearer ${ntoken}`;
  }

  return bearerToken;
}
